import {Component, OnInit} from '@angular/core';
import {environment} from '../../../../../../environments/environment';
import {DateUtil} from '../../../../../util/date-util';
import {FirebaseService} from '../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {RegenradarBildMetadata} from '../../../../../model/regenradar/regenradar-bild-metadata';
import {catchError, map, shareReplay, take} from 'rxjs/operators';
import {AngularFireStorageReference} from '@angular/fire/storage';
import {ListResult, Reference} from '@angular/fire/storage/interfaces';

@Component({
  selector: 'app-radar-bilder-vorhersagen',
  templateUrl: './radar-bilder-vorhersagen.component.html',
  styleUrls: ['../radar-bilder.css', './radar-bilder-vorhersagen.component.css']
})
export class RadarBilderVorhersagenComponent implements OnInit {

  private imagePath = '/wetter/regenradar/transparent/vorhersagen/deutschland/';
  private storageBasUrl = `${environment.storageBasePath}${environment.firebaseConfig.storageBucket}`;

  //2022-10-14T06:20:00Z
  date: Date;
  radarImages$: Observable<RegenradarBildMetadata[]> | null;
  error$: Observable<boolean> = new Observable<boolean>();

  constructor(private firebaseService: FirebaseService) {
    this.date = new Date();
    this.date.setMinutes((Math.floor(this.date.getMinutes() / 5) * 5) - 5);
    this.date.setSeconds(0);
  }

  ngOnInit(): void {
    this.radarImages$ = null;
    setTimeout(() => this.loadImages(), 100);
  }


  private loadImages() {
    const dateWithoutOffsetStr = DateUtil.formatDate(this.removeOffset(this.date), 'yyyy-MM-ddTHH:mm:ss');

    this.radarImages$ = this.firebaseService.getFileListFromStorage(this.imagePath, `${dateWithoutOffsetStr}Z/medium/`)
      .pipe(take(1), map((listResult: ListResult) =>
        listResult.items.map(item => new RegenradarBildMetadata('M', 'deutschland', `${this.storageBasUrl}/${item.location.path}`))));

    this.error$ = this.radarImages$.pipe(shareReplay(1),
      catchError(err => {
        console.log('Fehler: ', err);
        return of(err);
      }));
  }

  reload() {
    this.loadImages();
  }

  removeOffset(date: Date) {
    return DateUtil.removeOffset(date);
  }
}
